const Z_INDEX = {
  DISABLED_OVERLAY: 1,
  NOT_INITIALIZED: 1,

  RESULT: 10,

  MENU: 50,

  /** ヘッダー */
  HEADER: 1000,
} as const

export default Z_INDEX
